// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"layoutWrapper--e086a"};